export default __webpack_public_path__ + "static/media/lg4.450c591f.jpg";